import React, { useState } from 'react';
import CategorySelect from './CategorySelect';
import SortDropdown from './SortDropdown';
import PromoToggle from './PromoToggle';
import {
    FilterBarContainer,
    FilterBarContent,
    FilterRow,
    ToggleFiltersButton,
    FilterIcon,
    ActiveFiltersContainer,
    ResultCount,
    ActiveFilterTag,
    ClearAllButton
} from './FilterBar.styled';

const FilterBar = ({
    activeCategory,
    activeSortId,
    promoOnly,
    availableCategories,
    sortOptions,
    onCategoryChange,
    onSortChange,
    onPromoToggle,
    onClearAll,
    hasActiveFilters,
    resultCount,
    isPromoAvailable
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const getCategoryName = () => {
        if (!activeCategory) return null;
        const category = availableCategories.find(c => c.id === activeCategory);
        return category?.namePlural;
    };

    const getSortName = () => {
        if (activeSortId === 'default') return null;
        const sortOption = sortOptions.find(s => s.id === activeSortId);
        return sortOption?.label;
    };

    return (
        <FilterBarContainer>
            <ToggleFiltersButton
                onClick={() => setIsExpanded(!isExpanded)}
                $hasFilters={hasActiveFilters}
                aria-expanded={isExpanded}
            >
                <FilterIcon>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                    </svg>
                </FilterIcon>
                Filtros {hasActiveFilters && '(activos)'}
            </ToggleFiltersButton>

            <FilterBarContent $isExpanded={isExpanded}>
                <FilterRow>
                    <CategorySelect
                        categories={availableCategories}
                        activeCategory={activeCategory}
                        onSelect={onCategoryChange}
                    />

                    <SortDropdown
                        options={sortOptions}
                        activeId={activeSortId}
                        onChange={onSortChange}
                    />

                    <PromoToggle
                        isActive={promoOnly}
                        onToggle={onPromoToggle}
                        isAvailable={isPromoAvailable}
                    />
                </FilterRow>
            </FilterBarContent>

            {hasActiveFilters && (
                <ActiveFiltersContainer>
                    <ResultCount>
                        {resultCount} {resultCount === 1 ? 'producto' : 'productos'}
                    </ResultCount>

                    {getCategoryName() && (
                        <ActiveFilterTag>
                            {getCategoryName()}
                        </ActiveFilterTag>
                    )}

                    {getSortName() && (
                        <ActiveFilterTag>
                            {getSortName()}
                        </ActiveFilterTag>
                    )}

                    {promoOnly && (
                        <ActiveFilterTag>
                            En Promoción
                        </ActiveFilterTag>
                    )}

                    <ClearAllButton onClick={onClearAll}>
                        Limpiar filtros
                    </ClearAllButton>
                </ActiveFiltersContainer>
            )}
        </FilterBarContainer>
    );
};

export default FilterBar;
